/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/097-download': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 9l4-4H9V1H7v4H4zm3.636-1.636l-1.121 1.121L14.579 10 8 12.453 1.421 10l4.064-1.515-1.121-1.121L0 9v4l8 3 8-3V9z"/>'
  }
})
